import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { settingsService } from 'src/services/settings.service'

export const useSignUpSettings = () => {
  return useQuery(QUERY_KEYS.SETTINGS_SIGN_UP, () => settingsService.getSignupSettings(), {
    keepPreviousData: true,
  })
}
